export default () => {

  if ($('.js-schedule-visit-link').length) {

    $('html').on('click', '.js-schedule-visit-link', function(event) {
      if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
        let target = $(this.hash);

        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

        if (target.length) {
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top - 100
          }, 500);
        }

        $(this).trigger('blur');
      }
    });

  }

};
